/* vue-kerlink version 3.0.3 */
//
//
//
//
//
//
//
//

var script = {
  props: {
    // Size: [sm|md|lg]
    size: {
      type: String,
      default: 'md'
    },
    // Progress in percentage
    progress: {
      type: Number,
      default: 0
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "loader",
      class: "loader-" + _vm.size,
      attrs: { title: _vm._f("number")(_vm.progress, "0", "", "%") }
    },
    [
      _c(
        "svg",
        { staticClass: "circular", attrs: { viewBox: "25 25 50 50" } },
        [
          _c("circle", {
            staticClass: "path",
            attrs: {
              cx: "50",
              cy: "50",
              r: "20",
              fill: "none",
              "stroke-width": "2",
              "stroke-miterlimit": "10"
            }
          })
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6ee49432_0", { source: ".loader[data-v-6ee49432] {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  margin: 0 auto;\n}\n.loader.loader-sm[data-v-6ee49432] {\n  width: 15px;\n}\n.loader.loader-md[data-v-6ee49432] {\n  width: 30px;\n}\n.loader.loader-lg[data-v-6ee49432] {\n  width: 50px;\n}\n.loader[data-v-6ee49432]::before {\n  display: block;\n  padding-top: 100%;\n  content: \"\";\n}\n.circular[data-v-6ee49432] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  transform-origin: center center;\n  animation: rotate-data-v-6ee49432 2s linear infinite;\n}\n.path[data-v-6ee49432] {\n  stroke: #1b3563;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: dash-data-v-6ee49432 1.5s ease-in-out infinite;\n}\n@keyframes rotate-data-v-6ee49432 {\n100% {\n    transform: rotate(360deg);\n}\n}\n@keyframes dash-data-v-6ee49432 {\n0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n}\n50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35;\n}\n100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124;\n}\n}\n\n/*# sourceMappingURL=ProgressCircular.vue.map */", map: {"version":3,"sources":["C:\\Users\\alg\\Workspace_Dashboard\\vue-kerlink\\src\\components\\ProgressCircular.vue","ProgressCircular.vue"],"names":[],"mappings":"AAiCA;EACA,kBAAA;EACA,qBAAA;EACA,WANA;EAOA,cAAA;AChCA;ADkCA;EACA,WAXA;ACrBA;ADmCA;EACA,WAdA;ACnBA;ADoCA;EACA,WAjBA;ACjBA;ADqCA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;ACnCA;ADuCA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,oDAAA;ACpCA;ADuCA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yDAAA;ACpCA;ADuCA;AACA;IACA,yBAAA;ACpCE;AACF;ADuCA;AACA;IACA,wBAAA;IACA,oBAAA;ACrCE;ADwCF;IACA,yBAAA;IACA,sBAAA;ACtCE;ADyCF;IACA,yBAAA;IACA,uBAAA;ACvCE;AACF;;AAEA,+CAA+C","file":"ProgressCircular.vue","sourcesContent":["<template>\n  <div :class=\"'loader-'+size\" :title=\"progress | number('0','','%')\" class=\"loader\">\n    <svg class=\"circular\" viewBox=\"25 25 50 50\">\n      <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\n    </svg>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: {\n    // Size: [sm|md|lg]\n    size: {\n      type: String,\n      default: 'md'\n    },\n    // Progress in percentage\n    progress: {\n      type: Number,\n      default: 0\n    }\n  }\n}\n</script>\n\n<style scoped lang=\"scss\">\n  // From https://codepen.io/jczimm/pen/vEBpoL\n  @import \"../scss/variables\";\n\n  $width-sm: 15px;\n  $width-md: 30px;\n  $width-lg: 50px;\n\n  .loader {\n    position: relative;\n    display: inline-block;\n    width: $width-md;\n    margin: 0 auto;\n\n    &.loader-sm {\n      width: $width-sm;\n    }\n\n    &.loader-md {\n      width: $width-md;\n    }\n\n    &.loader-lg {\n      width: $width-lg;\n    }\n\n    &::before {\n      display: block;\n      padding-top: 100%;\n      content: '';\n    }\n  }\n\n  .circular {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    transform-origin: center center;\n    animation: rotate 2s linear infinite;\n  }\n\n  .path {\n    stroke: $primary;\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite;\n  }\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 200;\n      stroke-dashoffset: 0;\n    }\n\n    50% {\n      stroke-dasharray: 89, 200;\n      stroke-dashoffset: -35;\n    }\n\n    100% {\n      stroke-dasharray: 89, 200;\n      stroke-dashoffset: -124;\n    }\n  }\n</style>\n",".loader {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  margin: 0 auto;\n}\n.loader.loader-sm {\n  width: 15px;\n}\n.loader.loader-md {\n  width: 30px;\n}\n.loader.loader-lg {\n  width: 50px;\n}\n.loader::before {\n  display: block;\n  padding-top: 100%;\n  content: \"\";\n}\n\n.circular {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  transform-origin: center center;\n  animation: rotate 2s linear infinite;\n}\n\n.path {\n  stroke: #1b3563;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: dash 1.5s ease-in-out infinite;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124;\n  }\n}\n\n/*# sourceMappingURL=ProgressCircular.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-6ee49432";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var ProgressCircular = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

export default ProgressCircular;
